// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1s-c6","rootSmall":"AddTileButton_rootSmall__2bxoQ"};